module.exports = __webpack_public_path__ + "static/LoveDateLogo-8e61cfd3c76b9daed19391eeae9d55b6.png";